var _rect, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMode(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    width: 30,
    height: 30,
    rx: 10,
    fill: "#53B175"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_21215)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.3307 15.7946L13.0427 10.4921L14.1646 9.36709C14.5386 8.94709 15.8849 9.01459 16.7899 9.60709C17.695 10.2071 17.8595 10.5671 18.9665 11.1821C19.8491 11.6621 20.799 12.1271 22.2949 11.8196L18.3307 15.7946ZM17.7997 16.3271L12.5116 11.0246L11.1877 12.3521C11.1184 12.4215 11.0634 12.5039 11.0259 12.5946C10.9883 12.6854 10.969 12.7826 10.969 12.8808C10.969 12.9791 10.9883 13.0763 11.0259 13.1671C11.0634 13.2578 11.1184 13.3402 11.1877 13.4096L11.9806 14.2046C12.2723 14.4971 12.2723 14.9771 11.9806 15.2696C11.5318 15.7196 10.911 16.1021 10.3276 16.5371C10.0658 16.7321 9.80402 16.9346 9.57216 17.1671C8.56989 18.1721 7.7995 19.5596 8.54746 20.3021C9.28793 21.0521 10.6717 20.2796 11.6739 19.2821C11.9058 19.0496 12.1077 18.7871 12.3097 18.5171C12.736 17.9321 13.1175 17.3096 13.5737 16.8596C13.6429 16.7901 13.7251 16.7349 13.8156 16.6973C13.9061 16.6596 14.0031 16.6403 14.101 16.6403C14.199 16.6403 14.296 16.6596 14.3865 16.6973C14.477 16.7349 14.5591 16.7901 14.6283 16.8596L15.4212 17.6546C15.7129 17.9471 16.1841 17.9471 16.4758 17.6546L17.7997 16.3271Z",
    fill: "#53B175"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_21215"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14.9591,
    height: 15,
    fill: "white",
    transform: "translate(7.5 7.5)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMode);
export default __webpack_public_path__ + "static/media/Mode.9151363abcf1e86ca7651bb3411e8124.svg";
export { ForwardRef as ReactComponent };